import styled from 'styled-components';

export const AmenitiesDetailsLoaderWrapDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: column;
  max-width: 120rem;
  margin: 0 auto;
  width:100%;
  background-color:${props.theme.colors.goWhite.base};
  border-radius:${props.theme.misc.borderRadius.large};
  margin-top:${props.theme.spacing.xlarge};

`,
);

export const AmenitiesDetailsLoaderHeaderWrapDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  padding:${props.theme.spacing.large};
  border-bottom: ${props.theme.misc.border.base} solid ${props.theme.colors.ash.medium};
  width:100%;
  justify-content: space-between;

`,
);

export const AmenitiesDetailsLoaderInnerHeaderDiv = styled.div(
  props => `

  display:flex;
  background-color:${props.theme.colors.goBrandBlue.medium};
  border-radius: ${props.theme.misc.borderRadius.small};
  width:13rem;
  height:1.6rem;

`,
);

export const AmenitiesDetailsLoaderListWrapDiv = styled.div(
  props => `

  display:flex;

  flex-direction: row;
  padding: ${props.theme.spacing.large};;
  margin-top:${props.theme.spacing.xlarge};
  margin-bottom:${props.theme.spacing.base};
  width:100%;

`,
);

export const AmenitiesDetailsLoaderListInnerWrapDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  margin-right: ${props.theme.spacing.custom(15)};

`,
);

export const AmenitiesDetailsLoaderIconDiv = styled.div(
  props => `

  display:flex;
  background-color:${props.theme.colors.goBrandBlue.medium};
  border-radius: ${props.theme.misc.borderRadius.small};
  margin-right: ${props.theme.spacing.custom(8)};
  width:1.68rem;
  height:1.6rem;

`,
);

export const AmenitiesDetailsLoaderTitleWrapDiv = styled.div(
  props => `

  display:flex;
  background-color:${props.theme.colors.goBrandBlue.medium};
  border-radius: ${props.theme.misc.borderRadius.small};
  width:8rem;
  height:1.6rem;

`,
);

export const AmenitiesDetailsLoaderTitleLargeWrapDiv = styled.div(
  props => `

  display:flex;
  background-color:${props.theme.colors.goBrandBlue.medium};
  border-radius: ${props.theme.misc.borderRadius.small};
  width:12rem;
  height:1.6rem;

`,
);
